import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import axios, { post } from 'axios';
import { MdCloudUpload } from 'react-icons/md';
import { FILE_URL } from '../../../@jumbo/constants/AppConstants';

let fileUpload = (file, IDana, fileUploaded, unloaded, setLoading) => {
  const url = FILE_URL + '/fileReceiver.php';
  const formData = new FormData();
  formData.append('IDana', IDana);
  formData.append('avatar', file);
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return post(url, formData, config, unloaded).then(
    response => {
      console.log(response);
      setLoading(false);
      fileUploaded(response.data.url);
    },
    error => {
      console.log(error);
    },
  );
};

const Placeholder = () => (
  <div
    style={{
      padding: '20px',
      border: '2px dashed #ccc',
      borderRadius: '4px',
      textAlign: 'center',
      cursor: 'pointer',
    }}>
    <MdCloudUpload size={40} color="#ccc" />
    <p>Trascina qui il file o clicca per selezionare</p>
  </div>
);

export default function MyDropzone({ IDana, fileUploaded, load, unloaded, name }) {
  const [loading, setLoading] = React.useState(false);

  const onDrop = files => {
    setLoading(true);
    files.forEach(file => {
      fileUpload(file, IDana, fileUploaded, unloaded, setLoading);
    });
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <Placeholder />
      <p>max 8Mb</p>
      {loading && <p style={{ color: 'red' }}>Attendere...</p>}
      {name && <p>{name}</p>}
    </div>
  );
}
